// extracted by mini-css-extract-plugin
export var reservationPart6Text = "reservation-part-6-module--reservation-part-6-text--f6316";
export var reservationRecapContainer = "reservation-part-6-module--reservation-recap-container--9b70e";
export var reservationTitle = "reservation-part-6-module--reservation-title--09fc4";